import { isMemberId, type MemberId } from "../member-identity";

/** Only exceptions to procedure-level capture are planned. */
export interface ObservationLevel {
  observationId: MemberId;
  level: "trial";
}

export function observationLevelsProblem(plan: readonly ObservationLevel[] = []): string | undefined {
  const seen = new Set<string>();
  for (const entry of plan) {
    if (!isMemberId(entry.observationId) || entry.level !== "trial") return "Invalid observation level plan";
    if (seen.has(entry.observationId)) return `Observation '${entry.observationId}' is planned twice`;
    seen.add(entry.observationId);
  }
  return undefined;
}
